import React from 'react'
import { Typography, Box } from '@mui/material'
import { Link, useParams } from 'react-router'
import Layout from './Layout'
import GridCard from './GridCard'
import GridContainer from './GridContainer'
import AutoRedactTree from './AutoRedactTree'
import { useSelectedDataRoom } from 'hooks/useSelectedDataRoom'

export default function Redaction() {
  const { dataRoom } = useSelectedDataRoom()
  const { dataRoomKey = '' } = useParams()

  return <Layout>
    {!dataRoomKey && <Box><Typography variant='h5'>Please select a data room</Typography></Box>}
    {dataRoom && !dataRoom.redaction && !dataRoom.light && dataRoom.allow_redaction && <Typography variant='h5'>Please <Link to={`/data-room/${dataRoom.data_room}`}>activate redaction</Link> for the data room</Typography>}
    {dataRoom && !dataRoom.redaction && !dataRoom.light && !dataRoom.allow_redaction && <Typography variant='h5'>Redaction is not available for the data room</Typography>}
    {dataRoom && dataRoom.light && <Typography variant='h5'>Redaction is not available for Light Data Rooms</Typography>}
    {dataRoom && dataRoom.redaction && !dataRoom.light && <GridContainer>
      <GridCard sm={12}>
        <Typography variant='h5'>
          Automatic redaction
        </Typography>
        <Typography variant='body2'>
          Click a folder to choose whether PDF files in it are automatically
          redacted. Folders without an explicit setting inherit it from
          their parent folder.
        </Typography>
        <AutoRedactTree dataRoom={dataRoom.data_room}/>
      </GridCard>
    </GridContainer>}
  </Layout>
}
